import { Component, OnInit } from '@angular/core';
import { OsobaRadnaOprema } from './osoba-radna-oprema';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-osoba-radna-oprema',
  templateUrl: './osoba-radna-oprema.component.html'
})
export class OsobaRadnaOpremaComponent 
extends BaseModalContainer<OsobaRadnaOprema> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<OsobaRadnaOprema>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService

  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
